/**
 * callFailureReason -- the short label for WHY a call failed, read from the
 * fields the server records for diagnosis (2026-10-05):
 * `failure_reason` (stable code) and `sip_response_code` (raw SIP code).
 *
 * The codes are derived server side in
 * server/src/domain/calling/callDiagnostics.ts; this module only maps them to
 * the `dialer:callFailure.*` catalog. A call with no failure reason gets no
 * label (null), never a guessed one. An unknown code falls back to
 * "Echec (code X)" with the raw SIP code, never the raw machine value.
 */

type TranslateWithParams = (key: string, params?: Record<string, unknown>) => string;

const OTHER_KEY = 'dialer:callFailure.other';

/** failure_reason value -> full i18n key (static, so the resolution check sees it) */
export const FAILURE_REASON_I18N_KEY: Record<string, string> = {
  number_not_found: 'dialer:callFailure.numberNotFound',
  busy: 'dialer:callFailure.busy',
  unavailable: 'dialer:callFailure.unavailable',
  rejected: 'dialer:callFailure.rejected',
  network_loop: 'dialer:callFailure.networkLoop',
  other: OTHER_KEY,
};

export interface CallFailureFields {
  failure_reason?: string | null;
  sip_response_code?: string | null;
}

export function callFailureLabel(call: CallFailureFields | null | undefined, t: TranslateWithParams): string | null {
  const reason = call?.failure_reason;
  if (!reason) return null;
  const key = FAILURE_REASON_I18N_KEY[reason] ?? OTHER_KEY;
  return t(key, { code: call?.sip_response_code || '?' });
}
